<template>
    <b-tab title="รายงานจากผู้ขับ">
        <b-card-body>
            <b-row>
                <b-col cols="12" class="mb-3">
                    <label>สถานะงาน</label>
                    <div>
                        <b-badge
                            :variant="getStatusBadgeVariant(form.statusJob)"
                            class="my-2"
                        >
                            {{ getStatusBadgeText(form.statusJob) }}
                        </b-badge>
                    </div>
                </b-col>
                <b-col cols="6">
                    <b-form-group 
                        label="พนักงานขับรถ"
                    >
                        <b-form-input
                            v-model="form.driver.fullName"
                            placeholder="พนักงานขับรถ"
                            disabled
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group 
                        label="เวลาขึ้นงาน"
                    >
                        <b-form-input
                            type="datetime-local"
                            v-model="form.driverTimeStart"
                            disabled
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr class="my-3" />
            <b-row>
                <b-col>
                    <b-tabs content-class="mt-3" class="tab-data-route">
                        <b-tab active title="ข้อมูลเส้นทาง">
                            <JobRoute :form="form" />
                        </b-tab>
                        <b-tab title="งานเพิ่มเติม">
                            <JobAddOn />
                        </b-tab>
                        <b-tab title="ค่าใช้จ่ายเพิ่มเติม">
                            <JobExpenses />
                        </b-tab>
                    </b-tabs>
                </b-col>
                <!-- <b-col cols="12" class="my-2">
                    <h4 class="text-muted">ข้อมูลเส้นทาง</h4>
                </b-col> -->
                <b-col cols="12">
                    <!-- <b-card no-body>
                        <b-tabs pills card vertical nav-wrapper-class="w-25" class="tab-routes">
                            <b-tab active v-for="(route , index) in form.routes" :key="index">
                                <template slot="title">
                                    <h3 class="text-white">
                                        {{ index === 0 ? 'ต้นทาง' : 'ปลายทาง' }}
                                    </h3>
                                </template>
                                <b-row>
                                    <b-col lg="12">
                                        <h4 class="text-muted">รายละเอียดต้นทาง</h4>
                                    </b-col>
                                    <b-col lg="12" cols="12">
                                        <b-row>
                                            <b-col lg="6">
                                                <b-form-group 
                                                    label="สถานที่"
                                                >
                                                    <b-form-input
                                                        placeholder="สถานที่"
                                                        v-model="route.name"
                                                        disabled
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col lg="6">
                                                <b-form-group 
                                                    label="ไมล์เริ่มงาน"
                                                >
                                                    <b-form-input
                                                        placeholder="ไมล์เริ่มงาน"
                                                        disabled
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-list-group>
                                                    <b-list-group-item
                                                        class="d-flex justify-content-between align-items-center py-3 border-right-0 border-left-0"
                                                        role="tab"
                                                        href="javascript:;"
                                                        v-b-toggle="`location_1`"
                                                    >
                                                        <span class="h3">
                                                            รูปไมล์เริ่มงาน
                                                        </span>
                                                        <i
                                                            class="ni"
                                                            :class="
                                                                true ? 'ni-bold-up' : 'ni-bold-down'
                                                        "></i>
                                                    </b-list-group-item>
                                                    <b-collapse id="`location_1`">
                                                        <b-card>
                                                            <b-card-body>
                                                                <b-row>
                                                                    <b-col cols="3">
                                                                        <img src="" alt="" class="image-max-size" />
                                                                    </b-col>
                                                                </b-row>
                                                            </b-card-body>
                                                        </b-card>
                                                    </b-collapse>
                                                </b-list-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card> -->
                    <!-- <b-row>
                        <template v-if="form.routes.length > 0">
                            <b-col lg="4" cols="4">
                                <div class="route-track pt-4">
                                    <div 
                                        class="route-track-step" 
                                        v-for="(route , index) in form.routes" 
                                        :key="index"
                                        @click="selectedRoute(index)"
                                    >
                                        <div class="route-track-status">
                                            <span class="route-track-status-dot"></span>
                                            <span class="route-track-status-line"></span>
                                        </div>
                                        <div class="route-track-text flex-fill">
                                            <div class="title-route">
                                                <h3 class="text-route">
                                                    {{ index === 0 
                                                        ? 'ต้นทาง' 
                                                        : index === form.routes.length - 1 
                                                        ? 'ปลายทาง' 
                                                        : `ระหว่างทาง จุดที่ ${index}`
                                                    }}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col lg="8" cols="8">
                                <b-col lg="12" class="px-0">
                                    <h4 class="text-muted">รายละเอียดต้นทาง</h4>
                                </b-col>
                                <b-row>
                                    <b-col lg="6">
                                        <b-form-group 
                                            label="สถานที่"
                                        >
                                            <b-form-input
                                                placeholder="สถานที่"
                                                v-model="form.routes[indexSelected].name"
                                                disabled
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-form-group 
                                            label="ไมล์เริ่มงาน"
                                        >
                                            <b-form-input
                                                placeholder="ไมล์เริ่มงาน"
                                                disabled
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-list-group>
                                            <b-list-group-item
                                                class="d-flex justify-content-between align-items-center py-3 border-right-0 border-left-0"
                                                role="tab"
                                                href="javascript:;"
                                                v-b-toggle="`route-1`"
                                            >
                                                <span class="h3">
                                                    <i 
                                                        class="text-primary" 
                                                        :class="'fas fa-circle'"
                                                    />
                                                    รูปไมล์เริ่มงาน <small class="text-muted">(0 รูป)</small>
                                                </span>
                                                <i
                                                    class="ni"
                                                    :class="
                                                        form.routes[indexSelected].visible ? 'ni-bold-up' : 'ni-bold-down'
                                                "></i>
                                            </b-list-group-item>
                                            <b-collapse id="route-1" v-model="form.routes[indexSelected].visible">
                                                <b-card no-body>
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col cols="3">
                                                                <img src="" alt="" class="image-max-size" />
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-card>
                                            </b-collapse>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col lg="12" class="my-4 text-center">
                                <h4 class="text-muted">ยังไม่มีเส้นทางในขณะนี้</h4>
                            </b-col>
                        </template>
                    </b-row> -->
                </b-col>
            </b-row>
        </b-card-body>
    </b-tab>
</template>

<script>
import { getStatusBadgeVariant, getStatusBadgeText } from "@/util/constants.js"
import JobRoute from "./JobRoute.vue";
import JobAddOn from "./JobAddOn.vue";
import JobExpenses from "./JobExpenses.vue";

export default {
    components: { JobRoute, JobAddOn, JobExpenses },
    props:{
        form: {
            type: Object
        }
    },
    data () {
        return {
            getStatusBadgeVariant,
            getStatusBadgeText,
            // indexSelected: 0,
        }
    },
    // methods: {
    //     selectedRoute(index){
    //         this.indexSelected = index;
    //     }
    // }
}
</script>